import axios, { AxiosHeaders } from "axios";
import api from "./api";
import { forgotPasswordModel } from "../static/forgotPassword.model";

export async function forgotPassword(userIdentifier: string) {

    const url = "/v3/account/forgotpasswordnew";
    
    const body: forgotPasswordModel = {
        userIdentifier: userIdentifier,
        senderName: 'MySalusApp',
        destinationPageUrl: process.env.REACT_APP_BASE_URL + '/change-password?checkCode='
    }

    const headers: AxiosHeaders = new AxiosHeaders()
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('Accept', 'application/json');

    let result: any;

    await api.post(`${url}`, JSON.stringify(body), { 
    headers: headers,
    
    }).then((response)=> {
        result = response;
    });

    return result;
};

export async function resetPassword(newPassword: string, checkCode: string) {
    const url = "/v3/account/changeForgottenPassword";

    const body = {
        CheckCode: checkCode,
        NewPassword: newPassword 
    }

    const headers: AxiosHeaders = new AxiosHeaders()
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('Accept', 'application/json');
    
    return await api.post(`${url}`, JSON.stringify(body), { 
        headers: headers,
        validateStatus: () => true
    })


}


// Metodo che serve per controllare che il link di "Reset password" inviato sia ancora valido
export async function isValidLinkResetPsw(checkCode: string) {

    const url = "v3/account/checkRequestCode?CheckCode=" + encodeURIComponent(checkCode);

    const headers: AxiosHeaders = new AxiosHeaders()
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('Accept', 'application/json');

    return await api.get(url, {
        headers: headers
    })
}